import React from 'react';
import { IView } from 'interfaces/common';
import { IRoles } from 'interfaces/roles.interface';

const FileUploadView: IView = {
  key: 'viewFileUpload',
  title: 'Dodawanie pliku',
  roles: [IRoles.ADMINISTRATOR, IRoles.HR],
  view: React.lazy(() => import('./add-file-manage')),
  path: '/dodaj-plik',
};

export default FileUploadView;
